<template>
  <div class="cr-summary batch-kpis" :class="{'is-loading': loading}">
    <div class="cr-summary-item text-left">
      <small>Competência</small>
      <div class="cr-summary-value">{{ competenceLabel(competence) }}</div>
      <span class="cr-summary-hint">
        {{ loading ? '—' : `${totals.count || 0} lotes · ${totals.guides || 0} guias` }}
      </span>
    </div>
    <div class="cr-summary-item">
      <small>Faturado</small>
      <div class="cr-summary-value">{{ value(totals.informed) }}</div>
    </div>
    <div class="cr-summary-item">
      <small>Glosado</small>
      <div class="cr-summary-value" :class="{'text-error': totals.glossed > 0}">
        {{ value(totals.glossed) }}
      </div>
      <span class="cr-summary-hint" v-if="!loading && totals.informed > 0">
        {{ glossedPercent }} do faturado
      </span>
    </div>
    <div class="cr-summary-item">
      <small>Recuperado</small>
      <div class="cr-summary-value">{{ value(totals.recovered) }}</div>
      <span class="cr-summary-hint" v-if="!loading && appealCount > 0">
        {{ appealCount === 1 ? '1 lote em recurso' : `${appealCount} lotes em recurso` }}
      </span>
    </div>
    <div class="cr-summary-item">
      <small>Liberado</small>
      <div class="cr-summary-value">{{ value(totals.released) }}</div>
    </div>
    <div class="cr-summary-item done">
      <small>Recebido</small>
      <div class="cr-summary-value">{{ value(totals.paid) }}</div>
      <span class="cr-summary-hint" v-if="!loading && settledCount > 0">
        {{ settledCount === 1 ? '1 lote baixado' : `${settledCount} lotes baixados` }}
      </span>
    </div>
    <div class="cr-summary-item highlight">
      <small>A receber</small>
      <div class="cr-summary-value">{{ value(totals.receivable) }}</div>
    </div>
  </div>
</template>

<script>
import currency from '@/filters/currency';
import { competenceLabel } from '../service';

export default {
  props: {
    totals: {
      type: Object,
      default: () => ({}),
    },
    byStatus: {
      type: Object,
      default: () => ({}),
    },
    competence: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    glossedPercent() {
      const percent = (this.totals.glossed / this.totals.informed) * 100;
      return `${percent.toFixed(1).replace('.', ',')}%`;
    },
    appealCount() {
      return (this.byStatus.in_appeal && this.byStatus.in_appeal.count) || 0;
    },
    settledCount() {
      return (this.byStatus.settled && this.byStatus.settled.count) || 0;
    },
  },
  methods: {
    competenceLabel,
    value(amount) {
      return this.loading ? '—' : currency(amount || 0);
    },
  },
};
</script>
